export default __webpack_public_path__ + "static/media/car.d5634681.jpg";